module.exports = __webpack_public_path__ + "media/images/application/template/30-second-quote/used-mobile-d277b46d18c5fc5bce7ff444df9e79c5.png";